import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import cx from 'classnames';
import withOutsideClickListener  from '../../decorators/outside-click-listener';

import Popup from '../global/popup';

class BookerSelect extends Component {
  static defaultProps = {
    marginClass: 'marginField',
  }

  /* Lifecycle */

  componentDidUpdate(nextProps) {
    const { isActive, handleFocusFullQuickbookerPassenger } = this.props;

    const popupJustClosed = nextProps.isActive && !isActive;

    if (this.buttonDOM && popupJustClosed) {
      this.buttonDOM.focus();
    }

    if (handleFocusFullQuickbookerPassenger && typeof handleFocusFullQuickbookerPassenger === 'function' && nextProps.isActive !== isActive) {
      handleFocusFullQuickbookerPassenger(isActive);
    }
  }

  /* Rendering */

  render() {
    const {
      buttonText,
      currentID,
      isActive,
      marginClass,
      modifierClass,
      toggleActive,
    } = this.props;

    const classes = cx({
      'BookerSelect-button': true,
      'is-active': isActive,
    });

    return (
      <div className={ `BookerSelect-${marginClass} BookerSelect BookerSelect--${modifierClass}` }>
        <button
          className={ classes }
          id={ currentID }
          onClick={ toggleActive }
          ref={ (c) => this.setButtonRefDOM(c) }>
          { buttonText }
        </button>
        { isActive ? this.renderPopup() : null }
      </div>
    );
  }

  setButtonRefDOM(c) {
    const { onSetMiniBookerInputRef } = this.props;

    this.buttonDOM = ReactDOM.findDOMNode(c);

    if (onSetMiniBookerInputRef) {
      onSetMiniBookerInputRef(c);
    }
  }

  renderPopup() {
    const {
      idPopUpPaxSelector,
      modifierClass,
      popupContent,
      popupPosition,
      toggleActive,
      type,
    } = this.props;

    let finalClass = '';

    if (type) {
      finalClass = modifierClass + ' VacationBooker-popUpWidth';
    } else {
      finalClass = modifierClass;
    }

    return (
      <Popup
        className={ `BookerSelect-popup BookerSelect-popup--${finalClass}` }
        idPopUpPaxSelector={ idPopUpPaxSelector }
        position={ popupPosition }
        type={ type }>
        { /* In the case of the BookerTripSelector, we need to know the toggleActive status
            higher up the component hierarchy, so popupContent is a function which accepts
            the popupContent and renders content here dependent on it's value */ }
        { typeof popupContent === 'function' ? popupContent(toggleActive) : popupContent }
      </Popup>
    );
  }
}

export default withOutsideClickListener(BookerSelect);
